import { GridColumnType } from "../../../../data/gridColumnType";

export const reviewTimesheetGridConfig = {
    columns: [
        {
            name: "Employee Name",
            fieldName: "name",
            // colStyle: { width: "20%", },
        },
        // {
        //     name: "team Name",
        //     fieldName: "teamName",
        // },
        {
            name: "Re Open ",
            fieldName: "reopenTimeSheet",
            // colStyle: { width: "20%", },
        },
        {
            name: "Open ",
            fieldName: "openTimeSheet",
            // colStyle: { width: "20%", },
        },
        {
            name: "Submited ",
            fieldName: "submitedTimesheet",
            // colStyle: { width: "20%", },
        },
        {
            name: "Re Submited ",
            fieldName: "reSubmitedTimesheet",
            // colStyle: { width: "20%", },
        },
        {
            name: "Approved ",
            fieldName: "approvedTimeSheet",
            // colStyle: { width: "20%", },
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: false,
            },
        },
    ],
};